import { useTranslation } from 'react-i18next';

import Button from '../../atoms/Button/Button';
import Modal, { ModalHeader } from '../Modal/Modal';
import modalStyles from '../Modal/Modal.module.css';

/**
 * Confirmation modal before running a dashboard action
 * @param {object} props
 * @param {string} [props.id='modal-dashboard-action-confirm']
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {() => void} props.onConfirm
 * @param {string | null} [props.message]
 * @param {boolean} [props.isLoading=false]
 * @returns {JSX.Element}
 */
function DashboardActionConfirmModal({
  id = 'modal-dashboard-action-confirm',
  isOpen,
  onClose,
  onConfirm,
  message = null,
  isLoading = false,
}) {
  const { t } = useTranslation();

  return (
    <Modal
      id={id}
      isOpen={isOpen}
      onClose={onClose}
      header={(
        <ModalHeader
          title={t('dashboard.actions.confirmTitle')}
          onClose={onClose}
        />
      )}
    >
      <p className={modalStyles['modal-message']}>
        {message}
      </p>
      <div style={{
        display: 'flex', justifyContent: 'flex-end', gap: 'var(--spacing-s)', marginTop: 'var(--spacing-m)',
      }}
      >
        <Button
          color="primary100"
          size="small"
          onClick={onClose}
          disabled={isLoading}
        >
          {t('dashboard.actions.cancel')}
        </Button>
        <Button
          color="primary"
          size="small"
          onClick={onConfirm}
          isLoading={isLoading}
          disabled={isLoading}
        >
          {t('dashboard.actions.confirm')}
        </Button>
      </div>
    </Modal>
  );
}

export default DashboardActionConfirmModal;
